import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Duplicates ~/components/AreaDetails/AreaTeams/TeamPanelRow.js
import PropTypes from 'prop-types';
import { mergeClassNames } from '../../../utils';
const TeamPanelRow = ({ label, value, className, }) => (_jsxs("div", { className: "flow-root pr-1 pt-1 pb-1", children: [_jsx("div", { className: "float-left text-gray-900", children: label }), _jsx("div", { className: mergeClassNames('float-right text-right text-gray-900}', className), children: value || 0 })] }));
TeamPanelRow.propTypes = {
    label: PropTypes.string,
    value: PropTypes.node,
    className: PropTypes.string,
};
export default TeamPanelRow;
